//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {IGroup} from '../../../types/group';
import {UserService} from '../../../services/user-service';
import {NotificationService} from '../../../services/notification-service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-reparent-dialog',
    templateUrl: './reparent-dialog.component.html',
    styleUrls: ['./reparent-dialog.component.scss'],
    standalone: false
})
export class ReparentDialogComponent implements OnInit {
  groups: IGroup[];
  parentGroups: IGroup[];
  selectedGroup: IGroup;
  selectedParentGroup: IGroup;

  fSuccess: string;
  fSaveError: string;
  fSelectError: string;

  constructor(
      public dialogRef: MatDialogRef<ReparentDialogComponent>,
      private userService: UserService,
      private notification: NotificationService,
      private translate: TranslateService,
  ) {
    this.translate.get(['SUCCESS', 'REPORT_SAVE_ERROR', 'ADM_REPARENT_CHOOSE_GROUP']).subscribe(vals => {
      this.fSuccess = vals['SUCCESS'];
      this.fSaveError = vals['REPORT_SAVE_ERROR'];
      this.fSelectError = vals['ADM_REPARENT_CHOOSE_GROUP'];
    });
  }

  ngOnInit(): void {
    this.userService.api_groups().subscribe(groups => this.groups = groups);
    this.userService.api_parent_groups().subscribe(parentGroups => this.parentGroups = parentGroups);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSelectedGroupChanged() {
    this.selectedParentGroup = this.parentGroups.find(g => g.id == this.selectedGroup.parent_id);
  }

  onSubmit() {
    if (!this.selectedParentGroup || !this.selectedGroup) {
      this.notification.showError(this.fSelectError);
    } else {
      this.userService.api_set_parent_group(this.selectedGroup.id, this.selectedParentGroup.id)
          .subscribe(
              () => {
                this.notification.showSuccess(this.fSuccess);
                this.dialogRef.close();
              },
              () => {
                this.notification.showError(this.fSaveError);
              }
          );
    }
  }
}
